// ThemeProvider.js
import ThemeContext from "context/ThemeContext";
import React, { useState } from "react";

function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [color, setColor] = useState("#FFFF");

  return (
    <ThemeContext.Provider value={{ color, setColor }}>
      {children}
    </ThemeContext.Provider>
  );
}

export default ThemeProvider;
